import { render, staticRenderFns } from "./todoDetails.vue?vue&type=template&id=68f4a63b&scoped=true"
import script from "./todoDetails.vue?vue&type=script&lang=js"
export * from "./todoDetails.vue?vue&type=script&lang=js"
import style0 from "./todoDetails.vue?vue&type=style&index=0&id=68f4a63b&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68f4a63b",
  null
  
)

export default component.exports